
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ProductDetails from '../../components/common/ProductDetails/ProductDetails';
import Footer from '../../components/common/Footer/Footer';


const ProductDetailsPage = () => {
  const { productUuid } = useParams();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      <ProductDetails
        productUuid={productUuid}
        open={true}
        onClose={handleClose}
      />
      <Footer sx={{ mt: 8 }} />
      
    </div>
  );
};

export default ProductDetailsPage;